import { useIntl } from '@capsicum/common';
import { usePartnerWalletTokenSummarySection } from '@capsicum/features/wallet/shared';

import { SummarySectionItem } from '../../../ui/wallet-partner-details';
import { SummarySectionWrapper } from '../WalletPartnerDetails.styled';

type TokenSummarySectionProps = {
	ledgerId: string;
	shortCode: string;
};

export const TokenSummarySection = ({ ledgerId, shortCode }: TokenSummarySectionProps) => {
	const { $t } = useIntl();
	const { isLoading, tokenSummary } = usePartnerWalletTokenSummarySection(ledgerId);

	if (isLoading) {
		return (
			<SummarySectionWrapper>
				<SummarySectionItem isLoading />
				<SummarySectionItem isLoading />
			</SummarySectionWrapper>
		);
	}

	return (
		<SummarySectionWrapper>
			<SummarySectionItem
				label={$t('wallet.partnerWallet.sections.tokenSummary.inUseTitle')}
				testID="walletPartnerDetails-tokenSummary-inUseAmount"
				tooltipPosition="bottom_right"
				tooltipText={$t('wallet.partnerWallet.sections.tokenSummary.inUseTooltipText')}
				tooltipTitle={$t('wallet.partnerWallet.sections.tokenSummary.inUseTooltipTitle')}
				value={`${tokenSummary?.inUseBalanceData} ${shortCode}`}
				withTooltip
			/>
			<SummarySectionItem
				label={$t('wallet.partnerWallet.sections.tokenSummary.tradableTitle')}
				testID="walletPartnerDetails-tokenSummary-tradableAmount"
				tooltipPosition="bottom_left"
				tooltipText={$t('wallet.partnerWallet.sections.tokenSummary.tradableTooltipText')}
				tooltipTitle={$t('wallet.partnerWallet.sections.tokenSummary.tradableTooltipTitle')}
				value={`${tokenSummary?.tradableBalance} ${shortCode}`}
				withTooltip
			/>
		</SummarySectionWrapper>
	);
};
